"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConsentType = void 0;
var UserConsentType;
(function (UserConsentType) {
    UserConsentType["avenMyTrackCredit"] = "avenMyTrackCredit";
})(UserConsentType || (exports.UserConsentType = UserConsentType = {}));
